import _, { isEmpty, sortBy, toNumber } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { SortOptions } from 'src/components/subHeader/SubHeaderWithSorting.interface';
import {
  useGetAllProducts,
  useGetProductCategories,
  useGetProductCategory,
  useGetProductsByCategory,
  useGetProductVariationTypes,
  useParamQuery,
} from 'src/hooks';
import { useApiErrorNavigator } from 'src/hooks/navigation';
import { IProduct } from 'src/interfaces';

import { filteredProducts } from '../modules/EditProductCategoryPage.helper';

export const useEditProductCategoryPage = (productCategoryId: string) => {
  const { data: productCardData = [], isLoading: productCardLoading } =
    useGetAllProducts([], [], undefined, []);
  const { data: productCategories = [], isLoading: productCategoryLoading } =
    useGetProductCategories(['sort=*name']);
  const { onChangeParams, activeFilters } = useParamQuery();
  const isDeleted = useRef(false);

  const { data: productCategory, error } = useGetProductCategory(
    productCategoryId,
    !isEmpty(productCategoryId) && !isDeleted.current,
  );
  const { data: productVariationTypes = [] } = useGetProductVariationTypes([
    'sort=*name',
  ]);

  const {
    data: selectedProductsData = [],
    isLoading: selectedProductsLoading,
  } = useGetProductsByCategory(
    productCategoryId,
    !isEmpty(productCategoryId) && !isDeleted.current,
  );

  const currentProductCategory = productCategories?.find(
    (category) => category.id === toNumber(productCategoryId),
  );

  const [productData, setProductData] = useState<IProduct[]>([]);

  const sortProducts = (
    products: IProduct[],
    selectedProductsData: IProduct[],
  ) => {
    const existingProducts = selectedProductsData.map(
      (product) => product.product_code,
    );

    if (existingProducts.length > 0) {
      return _(products)
        .chain()
        .sortBy('product_name')
        .reverse()
        .sortBy(function (item) {
          return existingProducts.includes(item.product_code);
        })
        .reverse()
        .value();
    } else {
      return sortBy(products, 'product_name');
    }
  };

  useApiErrorNavigator(error);

  useEffect(() => {
    if (productCardData.length > 0) {
      const filteredProductCardData = filteredProducts(
        productCardData,
        activeFilters,
        SortOptions.ALPHABETICALLY,
        'asc',
      );

      setProductData(
        sortProducts(filteredProductCardData, selectedProductsData),
      );
    }
  }, [productCardData, selectedProductsData, activeFilters]);

  return {
    productCardData: productData,
    allProducts: productCardData,
    productCategory,
    productVariationTypes,
    productCardLoading,
    productCategoryLoading,
    selectedProductsLoading,
    selectedProductsData,
    currentProductCategory,
    onChangeParams,
    productCategories,
    isDeleted,
  };
};
